import styled from 'styled-components';

export const Default = styled.div`
  padding: var(--layout-shoe) var(--layout-saxophone);
`;

export const FullPage = styled.div`
  background-color: var(--base-bg-primary);
  overflow: auto;
  padding: var(--layout-sandgrain);
  position: absolute;
  inset: 0;
  z-index: var(--z-order-floating-element);
`;
